function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 298,
  height: 261
}, React.createElement("rect", {
  width: 298,
  height: 261,
  transform: "matrix(1 0 0 -1 0 261)",
  fill: "#C4C4C4"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M164.753 30.0298H134.709V56.3181H164.753V30.0298Z",
  fill: "#2A7771"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.636 -0.0140381H170.825C171.624 -0.0140381 172.263 0.65959 172.263 1.50162V36.025C172.263 36.8671 171.624 37.5407 170.825 37.5407H128.636C127.836 37.5407 127.197 36.8671 127.197 36.025V1.50162C127.197 0.65959 127.836 -0.0140381 128.636 -0.0140381Z",
  fill: "#3CA19D"
}), React.createElement("path", {
  d: "M50.0653 56.301L37.0664 69.3036L54.9914 87.2235L67.9902 74.2209L50.0653 56.301Z",
  fill: "#2A7771"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.6584 57.2563L38.0294 37.8854C38.489 37.4257 39.2442 37.4257 39.7366 37.8854L60.3552 58.504C60.8148 58.9636 60.8148 59.7187 60.3552 60.1784L40.9843 79.5493C40.5246 80.009 39.7695 80.009 39.277 79.5493L18.6584 58.9308C18.1659 58.504 18.1659 57.7488 18.6584 57.2563Z",
  fill: "#3CA19D"
}), React.createElement("path", {
  d: "M250.274 56.3106L232.352 74.233L245.352 87.2338L263.275 69.3113L250.274 56.3106Z",
  fill: "#2A7771"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M262.335 37.8854L281.706 57.2563C282.165 57.716 282.165 58.4711 281.706 58.9636L261.087 79.5822C260.627 80.0418 259.872 80.0418 259.38 79.5822L240.009 60.2112C239.549 59.7516 239.549 58.9964 240.009 58.504L260.627 37.8854C261.12 37.4257 261.875 37.4257 262.335 37.8854Z",
  fill: "#3CA19D"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.093 45.4202C230.91 45.4202 297.273 111.784 297.273 193.601C297.273 275.418 230.957 341.781 149.093 341.781C67.2758 341.781 0.912109 275.465 0.912109 193.601C0.912109 111.784 67.2758 45.4202 149.093 45.4202Z",
  fill: "#2A7771"
}), React.createElement("path", {
  d: "M149.039 330.262C225.222 330.262 286.981 268.503 286.981 192.32C286.981 116.137 225.222 54.3784 149.039 54.3784C72.8562 54.3784 11.0977 116.137 11.0977 192.32C11.0977 268.503 72.8562 330.262 149.039 330.262Z",
  fill: "white"
}), React.createElement("path", {
  d: "M45.4831 112.533L40.9414 118.784L53.213 127.7L57.7547 121.449L45.4831 112.533Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M37.6719 123.787L33.8086 130.478L46.9448 138.062L50.8081 131.371L37.6719 123.787Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M31.0647 135.809L27.9199 142.867L41.7752 149.041L44.9199 141.983L31.0647 135.809Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M25.8297 148.452L23.4375 155.799L37.8616 160.496L40.2537 153.148L25.8297 148.452Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M21.8848 161.603L20.2754 169.16L35.112 172.32L36.7215 164.763L21.8848 161.603Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M19.35 175.049L18.5449 182.734L33.6318 184.314L34.437 176.629L19.35 175.049Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M33.3837 188.714H18.2148V196.441H33.3837V188.714Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M33.6084 200.848L18.5215 202.428L19.3266 210.113L34.4135 208.533L33.6084 200.848Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M35.1238 212.866L20.2871 216.026L21.8966 223.583L36.7332 220.424L35.1238 212.866Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M37.844 224.676L23.4199 229.372L25.8121 236.719L40.2361 232.023L37.844 224.676Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M41.8201 236.101L27.9648 242.275L31.1096 249.333L44.9648 243.159L41.8201 236.101Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M46.9461 247.112L33.8145 254.706L37.6824 261.395L50.8141 253.801L46.9461 247.112Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M53.2134 257.456L40.9434 266.374L45.4858 272.624L57.7559 263.706L53.2134 257.456Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M244.978 257.458L240.432 263.706L252.697 272.631L257.244 266.383L244.978 257.458Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M251.228 247.116L247.363 253.807L260.498 261.394L264.363 254.704L251.228 247.116Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M256.354 236.1L253.209 243.157L267.064 249.331L270.209 242.273L256.354 236.1Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M260.333 224.677L257.945 232.025L272.372 236.713L274.76 229.364L260.333 224.677Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M263.06 212.864L261.457 220.422L276.295 223.57L277.898 216.011L263.06 212.864Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M264.559 200.838L263.754 208.523L278.841 210.103L279.646 202.418L264.559 200.838Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M279.972 188.714H264.803V196.441H279.972V188.714Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M278.878 175.056L263.791 176.636L264.596 184.321L279.683 182.74L278.878 175.056Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M276.289 161.578L261.451 164.726L263.054 172.284L277.893 169.136L276.289 161.578Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M272.396 148.437L257.969 153.124L260.356 160.473L274.783 155.785L272.396 148.437Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M267.066 135.824L253.211 141.998L256.356 149.055L270.211 142.882L267.066 135.824Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M260.458 123.785L247.318 131.364L251.179 138.056L264.318 130.478L260.458 123.785Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M252.672 112.514L240.406 121.438L244.952 127.686L257.217 118.762L252.672 112.514Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M152.932 61.6748H145.205V76.8437H152.932V61.6748Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M139.225 62.0237L131.541 62.8335L133.131 77.9189L140.815 77.1092L139.225 62.0237Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M125.671 63.7305L118.113 65.3392L121.271 80.1759L128.829 78.5672L125.671 63.7305Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M112.343 66.9118L104.994 69.2993L109.681 83.7264L117.03 81.3389L112.343 66.9118Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M99.3505 71.4329L92.293 74.5776L98.4667 88.4328L105.524 85.2881L99.3505 71.4329Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M86.9862 77.3092L80.2988 81.1794L87.8969 94.3081L94.5843 90.4378L86.9862 77.3092Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M75.2559 84.4305L69.0059 88.9738L77.9251 101.244L84.1752 96.7006L75.2559 84.4305Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M64.4041 92.7422L58.6602 97.9105L68.8066 109.187L74.5506 104.019L64.4041 92.7422Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M54.3937 102.146L49.2207 107.885L60.4881 118.04L65.6611 112.301L54.3937 102.146Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M243.739 102.097L232.473 112.254L237.646 117.993L248.912 107.836L243.739 102.097Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M233.784 92.7348L223.639 104.013L229.383 109.18L239.528 97.9023L233.784 92.7348Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M222.908 84.4383L213.984 96.7039L220.232 101.249L229.156 88.9839L222.908 84.4383Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M211.153 77.3034L203.555 90.432L210.242 94.3023L217.84 81.1737L211.153 77.3034Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M198.803 71.4465L192.633 85.3032L199.691 88.4464L205.862 74.5897L198.803 71.4465Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M185.861 66.8951L181.174 81.3221L188.523 83.7097L193.21 69.2826L185.861 66.8951Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M172.543 63.7498L169.385 78.5864L176.942 80.1951L180.1 65.3585L172.543 63.7498Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M158.926 62.0028L157.336 77.0883L165.02 77.898L166.61 62.8126L158.926 62.0028Z",
  fill: "#B9D0FE"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  x: -8,
  y: -19,
  width: 315.085,
  height: 360.734,
  fill: "white"
})));

var SvgTimer = function SvgTimer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 298,
    height: 261,
    viewBox: "0 0 298 261",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer.b71d2c1d.svg";
export { ForwardRef as ReactComponent };